(function () {
  'use strict';

  // CEL | The stage's screenful, measured off a probe and written back in px.
  // Only the width is allowed to change it: mobile browser bars move the height
  // as you scroll, and a height that follows them resizes the box under the
  // background video, which reads as the video zooming.
  var lockedWidth = -1;
  var lockedHeight = 0;

  function measureScreen() {
    var probe = document.createElement('div');

    probe.style.cssText = 'position:absolute;top:0;left:0;width:0;visibility:hidden;pointer-events:none';
    probe.style.height = '100lvh';
    if (!probe.style.height) probe.style.height = '100vh';

    document.body.appendChild(probe);
    var height = probe.getBoundingClientRect().height;
    probe.parentNode.removeChild(probe);

    return height;
  }

  function lockStageHeight() {
    var width = window.innerWidth;
    var height = Math.max(measureScreen(), window.innerHeight);
    if (!height) return;

    // CEL | At the same width it can only grow, never shrink. Shrinking is the
    // resize that re-crops the video; growing only happens if the screen turned
    // out taller than lvh claimed, which is what would leave a strip below.
    if (width === lockedWidth && height <= lockedHeight) return;

    lockedWidth = width;
    lockedHeight = height;
    document.documentElement.style.setProperty('--teaser-stage-h', Math.round(height) + 'px');
  }

  function init(container) {
    var trigger = container.querySelector('#trigger-open');
    var overlay = container.querySelector('#teaser-overlay');
    var stage = container.querySelector('[data-coven-stage]');
    var reveal = stage
      ? stage.querySelector('[data-coven-step="intro"] .coven-club_cel__cta')
      : null;
    var close = stage ? stage.querySelector('[data-coven-close]') : null;

    function open() {
      if (overlay) overlay.classList.add('overlay-open');
    }

    function setRevealed(isRevealed) {
      if (!stage) return;
      stage.classList.toggle('is-revealed', isRevealed);
      if (reveal) reveal.setAttribute('aria-expanded', String(isRevealed));
    }

    function onReveal() {
      setRevealed(true);
    }

    // CEL | Focus follows the card back to the button that opened it, otherwise it
    // stays on the closed step and the next Tab starts from nowhere.
    function onClose() {
      setRevealed(false);
      if (reveal) reveal.focus();
    }

    if (trigger) trigger.addEventListener('click', open);

    if (reveal) {
      reveal.setAttribute('aria-expanded', 'false');
      reveal.addEventListener('click', onReveal);
    }

    if (close) close.addEventListener('click', onClose);

    container._teaserPageHandlers = {
      trigger: trigger,
      open: open,
      reveal: reveal,
      onReveal: onReveal,
      close: close,
      onClose: onClose,
      setRevealed: setRevealed,
    };
  }

  function unload(container) {
    var handlers = container._teaserPageHandlers;
    if (!handlers) return;

    if (handlers.trigger) handlers.trigger.removeEventListener('click', handlers.open);
    if (handlers.reveal) handlers.reveal.removeEventListener('click', handlers.onReveal);
    if (handlers.close) handlers.close.removeEventListener('click', handlers.onClose);

    delete container._teaserPageHandlers;
  }

  document.addEventListener('DOMContentLoaded', function () {
    lockStageHeight();

    document.querySelectorAll('.teaser-main_cel').forEach(function (container) {
      init(container);
    });
  });

  window.addEventListener('resize', lockStageHeight);
  window.addEventListener('orientationchange', lockStageHeight);

  document.addEventListener('shopify:section:load', function (event) {
    lockStageHeight();

    var container = event.target.querySelector('.teaser-main_cel');
    if (container) init(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('.teaser-main_cel');
    if (container) unload(container);
  });

  // CEL | Selecting either reveal block in the theme editor jumps to that step,
  // otherwise step 2 can't be edited without previewing the page.
  document.addEventListener('shopify:block:select', function (event) {
    var step = event.target.getAttribute('data-coven-step');
    if (!step) return;

    var container = event.target.closest('.teaser-main_cel');
    var handlers = container && container._teaserPageHandlers;
    if (handlers) handlers.setRevealed(step === 'details');
  });
})();
